import axios from 'axios'
import { getWorkerDetailsAPI } from '../api'

export const getWorkerDetails = async (workerId, bookingId) => {
    try {
        return await axios.get(getWorkerDetailsAPI(workerId, bookingId))
    } catch (error) {
        return { success: false, error: error.message }
    }
}
